/** Textes « nouvelleReservation » — le français fait foi. */
export const nouvelleReservation = {
  etapes: ['dates et véhicule', 'client', 'prix et validation'],
  etape: (n: number, nom: string) => `Étape ${n} sur 3 — ${nom}`,
  retourLe: (date: string, jours: number) => `Retour le ${date} — ${jours} jour(s). Le prix ne change pas.`,
  sinonHeure: (heure: string) => `(sinon ${heure} au départ comme au retour)`,
  article02: (ouverture: string, fermeture: string, heure: string) =>
    `L'article 02 prévoit une restitution entre ${ouverture} et ${fermeture}. Le retour est prévu à ${heure} — l'agence sera fermée.`,
  totalMois: (n: number) => `Total ${n} mois`,
  totalJours: (n: number) => `Total ${n} j`,
  ageMinimum: (age: number) => `${age} ans — minimum 28 ans exige (article 01)`,
  ans: (n: number) => `${n} ans`,
  permisMinimum: (n: number) => `Permis de ${n} an(s) — minimum 5 ans exigé (article 01)`,
  anciennete: (n: number) => `${n} ans d'ancienneté`,
  derogationAccordee: (message: string) => `Derogation accordee — ${message}`,
  motif: (motif: string) => `Motif : ${motif}`,
  prixNegocieMois: (devise: string) => `Prix négocié / mois (${devise})`,
  moisFoisPrix: (n: number, total: string) => `${n} mois × ce prix = ${total} — quel que soit le nombre de jours.`,
  prixNegocieJour: (devise: string) => `Prix négocié / jour (${devise})`,
  ecart: (pct: string) => `${pct} % par rapport au tarif de référence`,
  remiseTotal: (devise: string) => `Remise sur le total (${devise})`,
  joursFoisTarif: (jours: number, tarif: string, total: string) => `${jours} jour(s) × ${tarif} = ${total}`,
  localeNombre: 'fr-FR',
  dernierReleve: (km: string) => `Dernier relevé connu : ${km} km`,
  vidangeDepassee: (km: string) => `Vidange DÉPASSÉE de ${km} km — à faire avant de la sortir.`,
  vidangeProche: (km: string) => `Plus que ${km} km avant la vidange — cette location peut les consommer.`,
  vidangeReste: (km: string) => `Il reste ${km} km avant la prochaine vidange.`,
  verseMaintenant: (devise: string) => `Versé maintenant (${devise})`,
  totalAPayer: (total: string) => `Total à payer : ${total}`,
  echelonnes: (prevu: string, reste: string) => `${prevu} échelonnés sur ${reste} restant à payer`,
  ecartEcheances: (ecart: string) => ` — l'écart est de ${ecart}`,
  tranchesTexte: (verse: string, reste: string) =>
    `${verse} encaissés tout de suite. Les ${reste} restants partent dans « Dettes », marqués « solde de tranches » — c'est un accord, pas un oubli.`,
  montantDevise: (devise: string) => `Montant (${devise})`,
  prixNonSaisi: (devise: string) => `Prix non saisi — il serait facturé 0 ${devise}. À renseigner dans Paramètres.`,
  aHeure: (heure: string) => ` à ${heure}`,
  moisFois: (n: number, tarif: string) => `${n} mois × ${tarif}`,
  soitJours: (n: number) => `soit ${n} jour(s) — le prix ne change pas`,
  joursFois: (n: number, tarif: string) => `${n} jour(s) x ${tarif}`,
  versesDettes: (verse: string, reste: string) => `${verse} versés · ${reste} en dettes`,
  /** Le nom de la taxe quand les Paramètres n'en donnent pas. */
  taxeDefaut: 'TVA',
  taxeTaux: (taxe: string, taux: number) => `${taxe} ${taux} %`,
  locationAvecTaxe: (taxe: string, taux: number) => `Location avec ${taxe} (${taux} %)`,
  prixTtc: (taxe: string) => `Le prix devient TTC, et la facture portera la même ${taxe}.`,
  champDerogation: (message: string) => `dérogation article 01 — ${message}`,
  titre: 'Nouvelle location',
  datesVehicule: 'Dates et véhicule',
  facturerJour: 'Facturer au jour',
  facturerMois: 'Facturer au mois',
  depart: 'Départ',
  combienMois: 'Combien de mois',
  retour: 'Retour',
  preciserHeures: 'Préciser les heures',
  retourApresDepart: 'Le retour doit être après le départ.',
  rienDeLibre: 'Rien de libre sur cette période',
  changezDates: "Changez les dates, ou consultez l'écran Disponibilités pour voir quand les voitures se libèrent.",
  thVehicule: 'Véhicule',
  thImmatriculation: 'Immatriculation',
  tarifMois: 'Tarif / mois',
  tarifJour: 'Tarif / jour',
  pasTarifMois: 'pas de tarif au mois — à renseigner dans « Mes voitures »',
  client: 'Client',
  rechercher: 'Rechercher par nom ou téléphone',
  rechercherExemple: 'Bouzidi, 0661…',
  nouveauClient: 'Nouveau client',
  listeNoire: 'Liste noire',
  verificationImpossible: 'Vérification impossible',
  verificationTexte: "Les règles de l'article 01 — âge minimum et ancienneté du permis — n'ont pas pu être vérifiées auprès du serveur. Tant que la vérification n'aboutit pas, la location ne peut pas être créée : sans elle, un client non conforme passerait sans que personne ne le voie.",
  dateNaissance: 'Date de naissance',
  permisDelivreLe: 'Permis délivré le',
  listeNoireTexte: "Ce client a été mis en liste noire par l'agence. Seul un gérant peut passer outre.",
  derogeableTexte: 'Vous pouvez continuer : la location sera enregistrée avec cette réserve, et le journal gardera votre nom.',
  manqueTexte: "Cette information manque à la fiche du client. Vous pouvez continuer, mais la réserve restera au dossier tant qu'elle n'est pas complétée.",
  completerFiche: 'Compléter la fiche client',
  autoriserMalgreTout: 'Autoriser malgré tout',
  prevenirGerant: 'Prévenir un gérant',
  article01Ok: 'Article 01 respecté',
  article01OkTexte: 'Âge et ancienneté de permis conformes.',
  plusDisponible: "Cette voiture n'est plus disponible",
  plusDisponibleTexte: "La voiture retenue ne figure plus dans les disponibilités de ces dates — elle a probablement été prise entre-temps, ou les dates ont changé. Revenez à l'étape 1 pour en choisir une autre : rien n'a été enregistré.",
  revenirChoix: 'Revenir au choix de la voiture',
  prixNegocie: 'Prix négocié',
  prixNegocieTexte: "Le tarif affiché est un point de départ. L'écart n'est jamais bloqué — il est mesuré.",
  tarifRefMois: 'Tarif de référence / mois',
  pasTarifMoisErreur: "Cette voiture n'a pas de tarif au mois. Saisissez-en un ici, ou renseignez-le dans « Mes voitures ».",
  tarifRefJour: 'Tarif de référence / jour',
  auTarifRef: 'au tarif de référence',
  motifRemise: 'Motif de la remise',
  motifRemiseAide: 'Facultatif — il est imprimé sur le contrat.',
  motifRemiseExemple: 'Client fidèle, geste commercial…',
  kmIllimite: 'Kilométrage illimité ',
  kmSinon: '(sinon 250 km/jour, article 05)',
  kmCompteur: 'Kilométrage au compteur',
  aucuneVidange: "Aucune vidange enregistrée sur cette voiture : impossible de dire ce qu'il reste.",
  commentPaie: 'Comment le client paie',
  paiementSurPlace: 'Paiement sur place',
  paiementTranches: 'Paiement par tranches',
  paiementDiffere: 'Paiement différé',
  payeEn: 'Payé en',
  especes: 'Espèces',
  carte: 'Carte',
  cheque: 'Chèque',
  virement: 'Virement',
  traite: 'Traite',
  calendrier: 'Calendrier des versements à venir',
  montant: 'Montant',
  retirer: 'Retirer',
  ajouterEcheance: '+ Ajouter une échéance',
  datesImprimees: '. Ces dates seront imprimées sur le contrat.',
  surPlaceTexte: "Vous encaissez au comptoir. Tant que le solde n'est pas à zéro, le dossier reste dans « Dettes ».",
  tranchesVide: "Le client verse une partie maintenant, le reste plus tard. Saisissez ce qu'il donne aujourd'hui.",
  differeTexte: "Le client part sans payer : la location entre dans « Dettes » et y reste jusqu'au dernier dinar.",
  laCaution: 'La caution',
  forme: 'Forme',
  numeroPiece: 'Numéro de la pièce',
  numeroPieceAide: 'Le numéro du chèque ou de la traite, pour la décharge.',
  prendsMaintenant: 'Je la prends maintenant',
  cautionMaintenantTexte: "Le contrat s'établit dans la foulée, la caution est enregistrée et la décharge part à l'impression — le client repart avec son papier.",
  cautionPlusTardTexte: "La caution est seulement notée. Elle sera pré-remplie au moment d'établir le dossier.",
  supplementsDepart: 'Suppléments du départ',
  supplementsTexte: "Un seul catalogue : le siège bébé et le chauffeur additionnel vivent dans la même liste que le retard et le carburant. Ceux-ci s'ajoutent au départ.",
  aucunSupplement: 'Aucun supplément de départ au catalogue. Un gérant peut en ajouter dans',
  chemineSupplements: ' Paramètres › Suppléments',
  recapitulatif: 'Récapitulatif',
  periode: 'Période',
  kilometrage: 'Kilométrage',
  illimite: 'illimité',
  kmParJour: '250 km / jour',
  cautionConvenue: 'Caution convenue',
  paiement: 'Paiement',
  parTranches: 'par tranches',
  differeCredit: 'différé — à crédit',
  surPlace: 'sur place',
  remise: 'Remise',
  totalHt: 'Total hors taxes',
  totalTtc: 'Total TTC',
  total: 'Total ',
  derogationArticle01: "Dérogation a l'article 01",
  derogationJournal: 'Elle sera enregistrée au journal à votre nom.',
  chevauchement: 'Chevauchement',
  impossibleCreer: 'Impossible de créer',
  poserOption: 'Poser une option',
  demanderResponsable: 'Demander au responsable',
  motifObligatoire: 'Motif (obligatoire)',
  motifAide: 'Il sera conserve au journal, avec votre nom.',
  motifExemple: 'Client connu, accompagne par un conducteur experimente…',
  accorderDerogation: 'Accorder la dérogation',
  autoriserLocation: 'Autoriser la location',
  gerantPrevenu: 'Gérant prévenu',
  envoi: 'Envoi…',
  demandePartie: 'Votre demande est partie',
  demandeA: 'Elle apparaît dans ',
  demandeB: '« À valider »',
  demandeC: ' chez les gérants, avec le nom du client et votre motif. ',
  demandeD: 'La dérogation se donne sur cet écran',
  demandeE: " : quand l'un d'eux arrive, il se connecte ici avec son compte et lève le blocage.",
  pasLever: 'Vous ne pouvez pas lever ce blocage vous-même. Écrivez le motif et prévenez un gérant : il devra venir lever le blocage sur ce poste, en se connectant avec son compte. Son nom restera au journal.',
};
